import { Component, Input } from '@angular/core';

@Component({
  selector: 'libero-dip-advantage-card',
  templateUrl: './dip-advantage-card.component.html',
  styleUrls: ['./dip-advantage-card.component.scss'],
  standalone: false
})
export class DipAdvantageCardComponent {
  @Input() public advantageId = '';

  public unknownTypeIconPath = 'assets/icons/question-mark.svg';
  public mappedIcons: Record<string, string | undefined> = {
    'taxAdvantages': 'assets/icons/raise.svg',
    'wideChoices': 'assets/icons/chart-up-2.svg',
    'longTerm': 'assets/icons/hours-with-crowns.svg',
    'employerBonus': 'assets/icons/user-haired.svg',
    'changeOnFly': 'assets/icons/plus-money.svg',
  }
}
